import React, { useEffect, useState } from "react";
import iconEdit from "../../../assets/images/iconEdit.png";
import DashboardHeader from "@/components/DashboardHeader";
import DashboardLayout from "@/layouts/DashboardLayout";
import SelectSearchInput from "@/components/selectInput/SelectSearchInput";
import { SubmitHandler, useForm } from "react-hook-form";
import { AstericSign, FormHookInput, Input, Loader, Button, emailValidator, namePattern, NON_DIGIT_REGEX, STARTS_WITH_OPTIONAL_1_REGEX } from "@thdinc/hpf-shared";
import userDefaultImg from "../../../assets/images/defaultuser.jpg";
import { useLocation, useNavigate } from "react-router";
import Alert from "@/components/alert/Alert";
import { GET, PATCH_MULTIPART, POST_MULTIPART } from "@/services/api";
import { API_ROUTES } from "@/services/environment";
import { useAppSelector } from "@/hooks/hook";
import {
    ACCEPTED_IMAGE_TYPES,
    GENDER_DATA,
    MAX_FILE_SIZE_MB,
} from "@/constants/Common";
import useLoading from "@/hooks/useLoading";
import ChangesAlert from "@/components/alert/ChangesAlert";
import useError from "@/hooks/useError ";
import FormPasswordInput from "@/components/formHookInput/formPasswordInput";
import { UserBartender } from "../interface";

interface addBartender {
    isAdmin?: boolean;
    businessId?: string;
    next?: () => void;
    prev?: () => void;
}

type Inputs = {
    name: string;
    password: string;
    lastName: string;
    email: string;
    phone_number: string;
    fee: number;
};
const CreateAdmin: React.FC<addBartender> = ({ isAdmin, businessId, next, prev }) => {
    const { bartenders, businessAdmin } = API_ROUTES;
    const { refreshToken } = useAppSelector((store) => store.user);
    const { isLoading, startLoading, stopLoading } = useLoading();
    const [error, setCustomError] = useError()
    const [existingProfile, setExistingProfile] = useState<string | null>(null);

    const location = useLocation();
    const receivedData = location.state?.data;

    const {
        register,
        handleSubmit,
        reset,
        setValue,
        formState: { errors, isSubmitSuccessful },
    } = useForm<Inputs>();
    const [imageUrl, setImageUrl] = useState<File | null>(null);
    const [profile, setProfile] = useState<File | null>(null);
    const [isBartender, setIsBartender] = useState<boolean>(true);
    const [errorState, setErrorState] = useState<{
        name: string | null;
        error: string | null;
    }>({ name: "", error: "" });
    const [selectedGender, setSelectedGender] = useState<string>(
        receivedData?.gender ?? "Male"
    );
    const [selectLang, setSelectLang] = useState<string[]>(
        receivedData?.languages ?? []
    );

    const navigate = useNavigate();

    const [modal, setModal] = useState<boolean>(false);
    const [activeData, setActiveData] = useState<any | null>(null);
    const [adminData, setAdminData] = useState<UserBartender | null>(null)

    useEffect(() => {
        getData()
    }, [])

    const getData = async () => {
        // get the details of the admin data
        startLoading()
        try {
            const result = await GET(`${businessAdmin}/${businessId}`, refreshToken);
            const data = result.data.data
            if (result.data.success === true) {

                setAdminData(data)
                setValue("name", data?.first_name)
                setValue("lastName", data?.last_name)
                setValue("email", data?.email)
                setValue("email", data?.email)
                setValue("password", data?.password)
                setValue("phone_number", data?.phone_number)
                setSelectLang(data?.languages)
                setExistingProfile(data?.avatar)

            }
        } catch (err) {
            console.log(String(err));
        } finally {
            stopLoading();

        }
    }

    const selectGenderFun = (gender: string) => {
        setSelectedGender(gender);
        if (errorState.name === "gender") {
            setErrorState({ name: null, error: null });
        }
    };

    const selectLangFun = (checked: boolean, lang: string) => {
        if (checked) {
            setSelectLang([...selectLang, lang]);
            setErrorState({ name: null, error: null });
        } else {
            setSelectLang(selectLang.filter((item) => item !== lang));
        }
    };

    /* istanbul ignore next */
    const onSubmit: SubmitHandler<Inputs> = async (data) => {
        try {
            if (
                ((profile || existingProfile) && selectedGender !== "null" && selectLang.length !== 0)
            ) {
                startLoading();
                const formData = new FormData();
                formData.append("first_name", data.name);
                formData.append("last_name", data.lastName);
                formData.append("gender", selectedGender);
                formData.append("email", data.email);
                formData.append("phone_number", data.phone_number);
                formData.append("password", data.password);

                formData.append("language", JSON.stringify(selectLang));
                if (isAdmin && businessId) {
                    formData.append("is_admin", isAdmin.toString())
                    formData.append("business_id", businessId)
                    formData.append("is_bartender", isBartender.toString())
                }
                // if profile image selected
                if (profile) {
                    formData.append("avatar", profile);
                }
                if (imageUrl) {
                    formData.append("other_photos", imageUrl);
                }
                setActiveData(formData);
                setModal(true);
            }

            //if user wants to edit admin profile
            if (!profile && !existingProfile) {
                setErrorState({ name: "dp", error: "Please upload profile image" });
            } else if (selectedGender === "null") {
                setErrorState({ name: "gender", error: "Please select a gender" });
            } else if (selectLang.length === 0) {
                setErrorState({ name: "lang", error: "Please select a language" });
            }
        } catch (error) {
            console.log(error);
        } finally {
            stopLoading();
        }
    };
    // const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });
    const handleProfileImg = (e: React.ChangeEvent<HTMLInputElement>) => {
        // profile image selection for admin
        const file = e.target.files?.[0];
        if (file) {
            if (ACCEPTED_IMAGE_TYPES.includes(file.type)) {
                if (file.size <= MAX_FILE_SIZE_MB * 1024 * 1024) {
                    // Convert MB to bytes
                    const fileWithTimestamp = addTimestampToFile(file);
                    setProfile(fileWithTimestamp); // Set profile image with timestamped file name
                    setErrorState({ name: null, error: null });
                } else {
                    setErrorState({
                        name: "dp",
                        error: `File size exceeds ${MAX_FILE_SIZE_MB} MB. Please choose a smaller image.`,
                    });
                }
            } else {
                //if wrong type of files selected
                setErrorState({
                    name: "dp",
                    error:
                        "Please select a valid image file (JPEG, PNG, GIF, BMP, or TIFF).",
                });
            }
        }
    };

    // in order to add time stamp in image file data
    function addTimestampToFile(file: File): File {
        const timestamp = Date.now(); // Get current timestamp
        const fileName = `${timestamp}_${file.name}`; // Add timestamp to file name
        return new File([file], fileName, { type: file.type }); // Create a new file object with timestamped name
    }
    const saveDetails = async () => {
        setModal(false);
        startLoading();
        let response
        try {
            //patch request for edit
            if (adminData) {
                response = await PATCH_MULTIPART(
                    bartenders + "/" + adminData?.id,
                    activeData,
                    refreshToken
                );
            } else {
                //post request for add new
                response = await POST_MULTIPART(
                    bartenders,
                    activeData,
                    refreshToken
                );
            }
            if (response.data.success) {
                Alert({ message: response?.data?.message });
                isAdmin ? next && next() : navigate("/");
            } else {
                Alert({ type: "error", message: response?.data?.message });
            }
            stopLoading();
        } catch (error) {
            console.log('error', error)
            setCustomError('add', 'Something went wrong')
            stopLoading();

            // Handle error
        }
    };

    // if ( !adminData) {
    //     return null
    // }

    return (
        <div>
            <DashboardHeader title={adminData ? "Update Admin" : "Add Admin"} />
            <form
                onSubmit={handleSubmit(onSubmit)}
                className="container mx-auto  md:gap-4"
            >
                {/* left div */}
                <div className="bg-white rounded-2xl border p-6 w-full shadow-md flex md:flex-row flex-col items-center gap-5 ">
                    <div className="flex flex-col  items-center  ">
                        <div className="justify-center relative flex ">
                            <img
                                className="mt-4 w-56 h-56 object-cover rounded-full  border-primary-red border-2 self-center"
                                src={
                                    profile
                                        ? URL.createObjectURL(profile)
                                        : existingProfile
                                            ? existingProfile
                                            : userDefaultImg
                                }
                            />
                            <div className="bg-primary-red absolute rounded-full p-2 bottom-0 ml-24  cursor-pointer">
                                <label className=" cursor-pointer">
                                    <img className="h-3 w-auto" src={iconEdit} />
                                    <input
                                        data-testid="handleUpload"
                                        accept="image/*"
                                        id="profile-img"
                                        onChange={handleProfileImg}
                                        type="file"
                                        className="hidden"
                                    />
                                </label>
                            </div>
                        </div>
                        <div className="text-center">
                            {errorState.name === "dp" && (
                                <p className="text-red-500 text-xs mt-1 py-">
                                    {errorState.error}
                                </p>
                            )}
                            <p className="text-gray-500 text-xs mt-2 md:w-8/12 mx-auto ">
                                Please upload an image in one of the accepted formats: JPEG, PNG
                            </p>
                        </div>
                    </div>
                    <div className="flex flex-col items-center justify-center mt-4 w-full">
                        <div className="flex gap-4 flex-col md:flex-row w-full  ">
                            <div className="w-full ">
                                <div className=" font-semibold my-2">First Name <AstericSign /></div>
                                <FormHookInput
                                    type="text"
                                    placeholder="First Name"
                                    register={register("name", {
                                        required: "First Name is required",
                                        maxLength: {
                                            value: 50,
                                            message:
                                                "First Name length can't be more than 50 characters.",
                                        },
                                        pattern: {
                                            value: namePattern, // allow letters, hyphens, and apostrophes, between 1 and 50 characters
                                            message: "Invalid first name format",
                                        },
                                    })}
                                    error={errors.name}
                                />
                            </div>
                            <div className="w-full ">
                                <div className=" font-semibold my-2">Last Name <AstericSign /></div>
                                <FormHookInput
                                    type="text"
                                    placeholder="Last Name"
                                    register={register("lastName", {
                                        required: "Last First Name is required",
                                        maxLength: {
                                            value: 50,
                                            message:
                                                "Last Name length can't be more than 50 characters.",
                                        },

                                        pattern: {
                                            value: namePattern, // allow letters, hyphens, and apostrophes, between 1 and 50 characters
                                            message: "Invalid Last Name format",
                                        },
                                    })}
                                    error={errors.lastName}
                                />
                            </div>
                        </div>
                        <div className="flex gap-4 w-full flex-col md:flex-row">
                            <div className="w-full ">
                                <div className=" font-semibold my-2">Gender <AstericSign /></div>
                                <SelectSearchInput
                                    data-testid="genderTestId"
                                    options={GENDER_DATA}
                                    value={adminData?.gender ? adminData?.gender : selectedGender}
                                    onChange={selectGenderFun}
                                />
                                {errorState.name === "gender" && (
                                    <p className="text-red-500 text-xs mt-1 py-">
                                        {errorState.error}
                                    </p>
                                )}
                            </div>
                            <div className="w-full ">
                                <div className=" font-semibold my-2">Phone</div>
                                <FormHookInput
                                    type="text"
                                    placeholder="Phone Number"
                                    register={register("phone_number", {
                                        required: false,
                                        // pattern: {
                                        //   value: phoneNumberPattern,
                                        //   message: "Please enter a valid U.S format.",
                                        // },
                                        onChange: (e) => {
                                            let { value } = e.target;
                                            // Remove all non-digit characters except the initial "+1 "
                                            value = value
                                                .replace(NON_DIGIT_REGEX, "")
                                                .replace(STARTS_WITH_OPTIONAL_1_REGEX, "1"); // Ensures it starts with "1"
                                            value = `+1 ${value.substring(1, 4)} ${value.substring(
                                                4,
                                                7
                                            )} ${value.substring(7, 11)}`.trim();
                                            e.target.value = value;
                                        },
                                    })}
                                    error={errors.phone_number}
                                />
                            </div>
                        </div>
                        <div className="flex gap-4 w-full flex-col md:flex-row">
                            <div className="w-full ">
                                <div className=" font-semibold my-2">Email <AstericSign /></div>
                                <FormHookInput
                                    type="email"
                                    // disabled={!!adminData}
                                    placeholder="Email"
                                    register={register("email", {
                                        required: "Email is required!",
                                        pattern: emailValidator,
                                    })}
                                    error={errors.email}
                                />
                            </div>
                            {

                                <div className="w-full ">
                                    <div className=" font-semibold my-2">Password <AstericSign /></div>
                                    <FormPasswordInput
                                        type="password"

                                        placeholder="Password"
                                        register={register("password", {
                                            required: "Password is required",
                                        })}
                                        error={errors.password}
                                    />
                                </div>
                            }
                        </div>

                        <div className="flex gap-4 w-full flex-col md:flex-row">


                            <div className="w-full ">
                                <div className=" font-semibold my-2">Language <AstericSign /></div>

                                <div className="flex justify-start mt-2 gap-5">
                                    <div className={`flex items-center gap-2 ${selectLang.includes("en") && "bg-[#ffeee5] "
                                        } px-3 py-2 rounded-full`}>
                                        <p>English</p>
                                        <Input
                                            className="cursor-pointer appearance-none h-5 w-5 border border-gray-300 rounded-full checked:bg-primary-red checked:border-transparent focus:outline-none"

                                            data-testid="englishLang"
                                            onChange={(e) => selectLangFun(e.target.checked, "en")}
                                            type="checkbox"
                                            checked={selectLang.includes("en")}
                                        />
                                    </div>
                                    <div className={`flex items-center gap-2  ${selectLang.includes("es") && "bg-[#ffeee5] "
                                        } px-3 py-2 rounded-full`}>
                                        <p>Spanish</p>
                                        <Input
                                            data-testid="spanishLang"
                                            onChange={(e) => selectLangFun(e.target.checked, "es")}
                                            checked={selectLang.includes("es")}
                                            className="cursor-pointer appearance-none h-5 w-5 border border-gray-300 rounded-full checked:bg-primary-red checked:border-transparent focus:outline-none"
                                            type="checkbox"
                                        />
                                    </div>
                                </div>
                                {errorState.name === "lang" && (
                                    <p className="text-red-500 text-xs mt-1 py-">
                                        {errorState.error}
                                    </p>
                                )}
                            </div>
                        </div>
                        {
                            <div className="flex justify-end mt-5 w-full gap-4">
                                <Button onClick={prev} disabled={isLoading}>
                                    {" "}
                                    Back
                                </Button>
                                <Button classes={
                                    "bg-primary-red text-white hover:bg-primary-red-button-hover "} type="submit" disabled={isLoading} data-testid="submitButton">
                                    {" "}
                                    {isLoading ? <Loader  color="bg-gray-50"  /> : "Next"}
                                </Button>
                            </div>
                        }


                        {error?.name === 'add' && <p className="text-primary-red text-center mt-">{error.message}</p>}

                    </div>
                </div>

            </form>
            <ChangesAlert
                title={"Save Changes"}
                desc={`Are you sure you want to save this changes?`}
                positiveButtonText={"Yes"}
                negativeButtonText={"Cancel"}
                handleDiscardChanges={() => {
                    setModal(false);
                }}
                handleSaveChanges={saveDetails}
                isOpen={modal}
            />
        </div>
    );
};

export default CreateAdmin;
